<template>
  <Dialog
    header=" "
    v-model:visible="showThisModelCheck"
    style="width: 550px; max-height: 90%"
    @hide="closeModalCheck()"
    :modal="true"
    :focusTrap="false"
  >
    <!-- Visit Type -->
    <div v-if="currentStep === 2">
      <form>
        <!-- second row -->
        <div class="row">
          <div class="col-lg-6" style="margin-left: 30px;">
            <div class="form-group m-b-40">
              <label
                for=""
                class="font-weight-bold"
                style="
                      margin-left: 0px;
                      margin-top: -21px;
                      "
                >DOS</label
              >
              <input
                tabindex="99"
                type="date"
                class="form-control required"
                id="Dos_1"
                v-model="Dos_1"
                placeholder=""
              />
            </div>
          </div>
        </div>

        <section id="step-1" class="section active m-b-40">
          <h2 class="font-weight-bold h3Spacing text-center">
            Select Visit Type
          </h2>
          <!--Checkbox-->
          <div class="form-group text-center">
            <div
              class="form-checkbox"
              v-for="(type, ndx01) in types"
              :key="type.visitTypeId"
              @click="visitTypeClick(ndx01)"
            >
              <input
                :tabindex="ndx01 + 1"
                v-if="currentSelectedTypeId == type.visitTypeId"
                required
                class="radio"
                type="radio"
                name=""
                value=""
                checked="checked"
              />
              <label class="checklabel" for="">{{ type.name }}</label>
            </div>
          </div>
          <!--Checkbox-->

          <div class="row">
            <div style="margin-left:300px;" class="card col" id="nextbtncard">
              <a href="#">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                  @click="nextStageClick(3)"
                />
              </a>
            </div>
          </div>
          <!-- </div> -->
        </section>
      </form>
    </div>
    <!-- END visit Type -->

    <!-- Visit Reason START -->
    <div v-if="currentStep === 3">
      <section id="step-1" class="section active m-b-40">
        <h2 class="font-weight-bold h3Spacing text-center">
          Select Visit Reason
        </h2>
        <!--Checkbox-->
        <div
          class="form-group text-center"
          v-for="(reason, ndx02) in visitTypeReasons"
          :key="ndx02"
          @click="reasonClick(ndx02)"
        >
          <div class="form-checkbox">
            <input
              v-if="currentSelectedReasonId == reason.visitDetailId"
              required
              class="radio"
              type="radio"
              name=""
              value=""
              checked="checked"
            />
            <label style="margin-bottom: -1.5rem;" class="checklabel">{{
              reason.reasonName
            }}</label>
          </div>
          <!--Checkbox-->
        </div>

        <div class="row">
          <div class="card col" id="backbtncard">
            <a href="#">
              <img
                src="assets/images/buttons/ba.png"
                alt=""
                class="img-fluid btn-start"
                id="backbtn"
              />
              <img
                src="assets/images/buttons/bahover.png"
                alt=""
                class="img-fluid btn-start img-top"
                id="backbtn"
                @click="nextStageClick(2)"
              />
            </a>
          </div>

          <div style="margin-left:60px;" class="card col" id="nextbtncard">
            <a href="#">
              <img
                src="assets/images/buttons/pi.png"
                alt=""
                class="img-fluid btn-start"
                id="nextbtn"
              />
              <img
                src="assets/images/buttons/pihover.png"
                alt=""
                class="img-fluid btn-start img-top"
                id="nextbtn"
                @click="nextStageClick(4)"
              />
            </a>
          </div>
        </div>
      </section>
    </div>

    <div v-if="currentStep === 4">
      <section id="step-3" class="section active m-b-40">
        <h3 class="font-weight-bold h3Spacing text-center">Basic Details</h3>
        <form class="floating-labels">
          <!-- first row -->
          <div class="row">
            <div class="col-lg-12">
              <div
                class="form-group"
                v-bind:class="[
                  basicDetails.firstName.length != 0 ? 'focused' : ' ',
                ]"
              >
                <input
                  type="text"
                  class="form-control required"
                  id="firstName"
                  aria-labelledby="firstName_label"
                  maxlength="60"
                  placeholder=""
                  required
                  v-model="basicDetails.firstName"
                /><span class="bar"></span>
                <label
                  for="firstName"
                  id="firstName_label"
                  style="margin-left: 0px"
                  >First Name</label
                >
              </div>
              <!-- first name -->
            </div>
            <div class="col-lg-12">
              <!-- last name -->
              <div
                class="form-group"
                v-bind:class="[
                  basicDetails.lastName.length != 0 ? 'focused' : '',
                ]"
              >
                <input
                  type="text"
                  class="form-control required"
                  id="lastName"
                  aria-labelledby="lastName_label"
                  maxlength="60"
                  placeholder=""
                  v-model="basicDetails.lastName"
                /><span class="bar"></span>
                <label
                  for="lastName"
                  id="lastName_label"
                  style="margin-left: 0px"
                  >Last Name</label
                >
              </div>
              <!-- last name -->
            </div>
          </div>
          <!-- first row -->

          <!-- second row -->
          <div class="row">
            <div class="col-lg-12">
              <div class="form-group m-b-40">
                <label
                  for=""
                  style="
                    margin-left: 0px;
                    margin-top: -21px;
                    "
                  >Date of Birth</label
                >
                <input
                  type="date"
                  class="form-control required"
                  id="dob"
                  v-model="basicDetails.dob"
                  placeholder=""
                /><span class="bar"></span>
              </div>
            </div>

            <div class="col-lg-12" style="margin-left: 88px;">
              <div class="form-group m-b-40">
                <input
                  class="input1"
                  type="radio"
                  value="Male"
                  name="radio33"
                  v-model="basicDetails.gender"
                  id=""
                />
                <label
                  style="margin-left: -100px; margin-top: 8px"
                  for="radio33"
                  class="btn btn-outline-info label1"
                  @click="setBasicRadio('Male')"
                >
                  Male
                </label>
                <input
                  class="input1"
                  type="radio"
                  value="Female"
                  name="radio33"
                  v-model="basicDetails.gender"
                  id=""
                />
                <label
                  style="margin-left: -42px; margin-top: 8px"
                  for="radio33"
                  class="btn btn-outline-info label1"
                  @click="setBasicRadio('Female')"
                >
                  Female
                </label>
                <input
                  class="input1"
                  type="radio"
                  value="Other"
                  name="radio33"
                  v-model="basicDetails.gender"
                  id=""
                />
                <label
                  style="margin-left: 33px; margin-top: 8px"
                  for="radio33"
                  class="btn btn-outline-info label1"
                  @click="setBasicRadio('Other')"
                >
                  Other
                </label>
                <label
                  for=""
                  style="
                       margin-left: -124px;
                       margin-top: -18px;
                    "
                  >Gender</label
                >
              </div>
            </div>
          </div>
          <!-- second row -->

          <!-- fourth row -->
          <div v-for="(val, ndx033) in choseBasic" :key="ndx033">
            <div class="row" v-if="val.question == 'SSN'">
              <div
                class="form-group m-b-40 col-12"
                style="margin-top: 20px"
                v-bind:class="[basicDetails.ssn.length != 0 ? 'focused' : '']"
              >
                <input
                  v-mask="'###-##-####'"
                  type="tel"
                  class="form-control"
                  id="ssn"
                  aria-labelledby="ssn_label"
                  placeholder=""
                  v-model="basicDetails.ssn"
                /><span class="bar"></span>
                <label for="ssn" id="ssn_label" style="margin-left: -6px"
                  >Social Security Number</label
                >
              </div>
            </div>
          </div>
          <!-- fourth row -->
        </form>

        <div class="row" id="td2">
          <div class="card col" id="backbtncard">
            <a href="#">
              <img
                src="assets/images/buttons/ba.png"
                alt=""
                class="img-fluid btn-start"
                id="backbtn"
              />
              <img
                src="assets/images/buttons/bahover.png"
                alt=""
                class="img-fluid btn-start img-top"
                id="backbtn"
                @click="nextStageClick(3)"
              />
            </a>
          </div>

          <div style="margin-left:60px;" class="card col" id="nextbtncard">
            <a href="#">
              <img
                src="assets/images/buttons/pi.png"
                alt=""
                class="img-fluid btn-start"
                id="nextbtn"
              />
              <img
                src="assets/images/buttons/pihover.png"
                alt=""
                class="img-fluid btn-start img-top"
                id="nextbtn"
                @click="nextStageClick(5)"
              />
            </a>
          </div>
        </div>
      </section>
    </div>
    <!-- Basic Details END -->

    <!-- Contact Information BEGIN -->
    <div v-if="currentStep === 5">
      <section id="step-4" class="section active m-b-40">
        <h3 class="font-weight-bold h3Spacing text-center">
          Contact Information
        </h3>
        <form class="floating-labels">
          <!-- third row -->
          <div class="row">
            <div
              v-for="(val, ndx044) in choseBasic"
              :key="ndx044"
              class="col-lg-12"
            >
              <div
                v-if="val.question == 'Phone'"
                class="form-group m-b-40"
                v-bind:class="[basicDetails.phone.length != 0 ? 'focused' : '']"
              >
                <input
                  v-mask="'###-###-####'"
                  type="tel"
                  class="form-control required"
                  id="phone"
                  aria-labelledby="phone_label"
                  placeholder=""
                  v-model="basicDetails.phone"
                /><span class="bar"></span>
                <label for="phone" id="phone_label" style="margin-left: 0px"
                  >Phone Number</label
                >
              </div>
            </div>
            <div
              v-for="(val, ndx043) in choseBasic"
              :key="ndx043"
              class="col-lg-12"
            >
              <div
                v-if="val.question == 'Email'"
                class="form-group m-b-40"
                v-bind:class="[basicDetails.email.length != 0 ? 'focused' : '']"
              >
                <input
                  type="email"
                  class="form-control required"
                  id="email"
                  aria-labelledby="email_label"
                  placeholder=""
                  maxlength="50"
                  v-model="basicDetails.email"
                /><span class="bar"></span>
                <label for="email" id="email_label" style="margin-left: 0px"
                  >Email</label
                >
              </div>
            </div>
          </div>
          <!-- third row -->
        </form>

        <div class="row" id="td2">
          <div class="card col" id="backbtncard">
            <a href="#">
              <img
                src="assets/images/buttons/ba.png"
                alt=""
                class="img-fluid btn-start"
                id="backbtn"
              />
              <img
                src="assets/images/buttons/bahover.png"
                alt=""
                class="img-fluid btn-start img-top"
                id="backbtn"
                @click="backStageClick(4)"
              />
            </a>
          </div>

          <div style="margin-left:60px;" class="card col" id="nextbtncard">
            <a href="#">
              <img
                src="assets/images/buttons/pi.png"
                alt=""
                class="img-fluid btn-start"
                id="nextbtn"
              />
              <img
                src="assets/images/buttons/pihover.png"
                alt=""
                class="img-fluid btn-start img-top"
                id="nextbtn"
                @click="nextStageClick(6)"
              />
            </a>
          </div>
        </div>
      </section>
    </div>
    <!-- Contact Information END -->

    <!-- Patient Information START -->
    <div v-if="currentStep === 11">
      <section id="step-8" class="section active m-b-40">
        <div class="col-12" id="strips1">
          <h4 class="font-weight-bold h3Spacing text-center">
            Visit Information
          </h4>
        </div>
        <table
          class="table table-responsive table-striped"
          style="table-layout: fixed;"
        >
          <tbody>
            <tr>
              <th id="td1">
                Visit Type
              </th>
              <td id="td1">{{ activeType.name }}</td>
            </tr>
            <tr>
              <th id="td1">
                Visit Reason
              </th>
              <td id="td1">
                {{ activeReason.reasonName }}
              </td>
            </tr>
          </tbody>
        </table>

        <div class="col-12" id="strips1" v-if="isNew == true">
          <h4 class="font-weight-bold h3Spacing text-center">
            Patient Information
          </h4>
        </div>
        <div class="col-12" id="strips1" v-else-if="isNew == false">
          <h4 class="font-weight-bold h3Spacing text-center">
            Patient Information
          </h4>
        </div>
        <table
          v-if="isNew == true"
          class="table table-responsive table-striped"
          style="table-layout: fixed;"
        >
          <tbody>
            <tr>
              <th id="td1">
                First Name
              </th>
              <td id="td1">
                {{ basicDetails.firstName }}
              </td>
            </tr>
            <tr>
              <th id="td1">
                Last Name
              </th>
              <td id="td1">
                {{ basicDetails.lastName }}
              </td>
            </tr>
            <tr>
              <th>
                Date of Birth
              </th>
              <td id="td1">{{ newValDOB }}</td>
            </tr>
            <tr>
              <th id="td1">
                Sex
              </th>
              <td id="td1">
                {{ basicDetails.gender }}
              </td>
            </tr>
            <tr v-if="valueSSN == 'SSN'">
              <th id="td1">
                SSN
              </th>
              <td v-if="basicDetails.ssn != ''" id="td1">
                {{ basicDetails.ssn }}
              </td>
              <td v-else id="td1">
                -
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-else-if="isNew == false"
          class="table table-responsive table-striped"
          style="table-layout: fixed;"
        >
          <tbody>
            <tr>
              <th id="td1">
                First Name
              </th>
              <td id="td1">
                {{ basicDetails.firstName }}
              </td>
            </tr>
            <tr>
              <th id="td1">
                Last Name
              </th>
              <td id="td1">
                {{ basicDetails.lastName }}
              </td>
            </tr>
            <tr>
              <th id="td1">
                Date of Birth
              </th>
              <td id="td1">{{ newValDOB }}</td>
            </tr>
            <tr>
              <th id="td1">
                Sex
              </th>
              <td id="td1">
                {{ basicDetails.gender }}
              </td>
            </tr>
            <tr v-if="valueSSN == 'SSN'">
              <th class="td1">
                SSN
              </th>
              <td v-if="basicDetails.ssn != ''" id="td1">
                {{ basicDetails.ssn }}
              </td>
              <td v-else id="td1">
                -
              </td>
            </tr>
          </tbody>
        </table>

        <div
          class="col-12"
          id="strips1"
          v-if="checkContact() == true && isNew == true"
        >
          <h4 class="font-weight-bold h3Spacing text-center">
            Contact Information
          </h4>
        </div>
        <div class="col-12" id="strips1" v-else-if="isNew == false">
          <h4 class="font-weight-bold h3Spacing text-center">
            Contact Information
          </h4>
        </div>
        <table
          v-if="isNew == true"
          class="table table-responsive table-striped"
          style="table-layout: fixed;"
        >
          <tbody>
            <div v-for="(val, ndxx22) in choseBasic" :key="ndxx22">
              <tr v-if="val.question == 'Email'">
                <th id="td1">
                  Email Address
                </th>
                <td id="td1">
                  {{ basicDetails.email }}
                </td>
              </tr>
            </div>

            <div v-for="(val1, ndxx23) in choseBasic" :key="ndxx23">
              <tr v-if="val1.question == 'Phone'">
                <th id="td1">
                  Phone Number
                </th>
                <td id="td1">
                  {{ basicDetails.phone }}
                </td>
              </tr>
            </div>
          </tbody>
        </table>

        <table
          v-else-if="isNew == false"
          class="table table-responsive table-striped"
          style="table-layout: fixed;"
        >
          <tbody>
            <tr>
              <th id="td1">
                Email Address
              </th>
              <td v-if="basicDetails.email != ''" id="td1">
                {{ basicDetails.email }}
              </td>
              <td v-else id="td1">
                -
              </td>
            </tr>
            <tr>
              <th id="td1">
                Phone Number
              </th>
              <td v-if="basicDetails.phone != ''" id="td1">
                {{ basicDetails.phone }}
              </td>
              <td v-else id="td1">
                -
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row" id="td2">
          <div class="card col" id="backbtncard">
            <a href="#">
              <img
                src="assets/images/buttons/ba.png"
                alt=""
                class="img-fluid btn-start"
                id="backbtn"
              />
              <img
                src="assets/images/buttons/bahover.png"
                alt=""
                class="img-fluid btn-start img-top"
                id="backbtn"
                @click="backStageClick(11)"
              />
            </a>
          </div>

          <div class="card col" id="nextbtncard">
            <a href="#">
              <img
                src="assets/images/buttons/se.png"
                alt=""
                class="img-fluid btn-start"
                id="nextbtn99"
              />
              <img
                src="assets/images/buttons/sehover.png"
                alt=""
                class="img-fluid btn-start img-top"
                id="prevbtn111"
                @click="saveCheckinInfo_1"
              />
            </a>
          </div>
        </div>
      </section>

      <section id="step-9" class="section active m-b-40">
        <div class="container form-container slide">
          <h3 class="text-center boldText">THANK YOU FOR VISITING VEINS</h3>
        </div>
      </section>
    </div>

    <!-- Grouping Section -->

    <section
      class="section active"
      style="margin-top: 50px;"
      v-if="currentStep === 12"
    >
      <div class="container form-container text-center slide">
        <div class="container text-center">
          <h3 class="font-weight-bold text-uppercase">
            Do you want to check-in any other patients?
          </h3>
        </div>
        <div
          class="list-group mb-3 patientListSize"
          v-if="patientList === null || patientList.length > 0"
        >
          <a
            class="list-group-item list-group-item-action"
            v-for="patient in patientList"
            :key="patient.groupId"
          >
            {{ patient.firstName + " " + patient.lastNameInitial }}
          </a>
        </div>

        <div class="row">
          <div class="card col">
            <button
              type="button"
              class="btn btn-warning"
              @click="cancelAddingMorePatients"
            >
              No
            </button>
          </div>

          <div class="card col">
            <button
              type="button"
              class="btn btn-success"
              @click="addMorePatients"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </section>
  </Dialog>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  name: "QuickCheckiniInfo",
  props: ["closemodel", "hideQuickCheckinInfo", "pat"],
  components: {},

  data() {
    return {
      NewPat: "",
      hideMain: true,
      showPagesMin: 1,
      showPagesMax: 5,

      vDos: new Date(),
      Dos_1: "",
      newdate: "",

      practName: "",
      call: {},
      call1: {},
      loaderTim1: {},

      loaderTim: {},
      sortColumn: 0,
      sortColumnOption: 0,
      isNew: false,
      patientId: 0,
      valueSSN: "",
      //loader
      loader: "",
      loader1: "",

      //pagina
      pageNumber: 1,
      pageSize: 50,
      orderByCol: 1,
      asc_desc: "asc",
      remeberOrder: "",
      firstTime: true,
      totalPages: 0,
      totalRows: 0,

      Insurance: {
        primaryInsuranceName: "",
        primaryInsuranceNumber: "",
        primaryInsuranceGroup: "",
        primaryInsuranceId: "",
        secondaryInsuranceName: "",
        secondaryInsuranceNumber: "",
        secondaryInsuranceGroup: "",
        secondaryInsuranceId: "",
      },
      PhysicianId: "",
      contactInfo: ["phone", "email"],
      choseBasic: [],
      demoClick: [],
      basicDetails: {
        pndx: 0,
        patientId: 0,
        firstName: "",
        lastName: "",
        currentdate: new Date(),
        dos: "",
        dob: "",
        gender: "",
        ssn: "",
        phone: "",
        email: "",
        address: "",
        city: "",
        zip: "",
        state: "",
      },
      newValDOB: "",
      emailRq: 0,
      phoneRq: 0,
      emailVal: "",

      suggestedPatients: [],
      showThisModel: false,
      CheckInData: [],
      currentSelectedReasonId: -1,
      showThisModelCheck: true,
      types: [],
      reasons: [],
      demos_1: [],
      actualDemos: [],
      actualQuestions: [],
      questionOptions: [],
      visitTypeQuestDemo: [],
      currentStep: 2,
      currentSelectedTypeId: -1,
      activeType: "",
      visitTypeReasons: "",
      patientList: null,
      groupId: "",
      groupColor: ""
    };
  }, // data
  methods: {
    addMorePatients() {
      this.types = [];
      this.reasons = [];
      this.currentSelectedTypeId = -1;
      this.demos_1 = [];
      this.basicDetails = {
        pndx: 0,
        patientId: 0,
        firstName: "",
        lastName: "",
        currentdate: new Date(),
        dos: "",
        dob: "",
        gender: "",
        ssn: "",
        phone: "",
        email: "",
        address: "",
        city: "",
        zip: "",
        state: "",
      };
      this.showQuickCheckinInfo();
      this.currentStep = 2;
    },
    cancelAddingMorePatients() {
      this.types = [];
      this.reasons = [];
      this.currentSelectedTypeId = -1;
      this.demos_1 = [];
      this.basicDetails = {
        pndx: 0,
        patientId: 0,
        firstName: "",
        lastName: "",
        currentdate: new Date(),
        dos: "",
        dob: "",
        gender: "",
        ssn: "",
        phone: "",
        email: "",
        address: "",
        city: "",
        zip: "",
        state: "",
      };
      this.showThisModelCheck = false;
      this.showThisModel = false;
      this.loader.hide();
    },
    showModal(groupId, groupColor) {
      this.$emit("show-modal", groupId, groupColor);
    },
    closeModalCheck() {
      this.types = [];
      this.reasons = [];
      this.currentSelectedTypeId = -1;
      this.demos_1 = [];
      this.hideQuickCheckinInfo();
    },
    reasonClick(ndx) {
      this.currentSelectedReasonId = this.visitTypeReasons[ndx].visitDetailId;
      this.activeReason = "";
      this.activeReason = JSON.parse(
        JSON.stringify(this.visitTypeReasons[ndx])
      );
      this.PhysicianId = this.visitTypeReasons[0].physicianId;

      //setBasic Detail
      this.choseBasic = [];
      this.demoClick = this.demos_1.filter(
        (i) => i.visitDetailId == this.currentSelectedReasonId
      );
      this.filterList();
    },
    filterList() {
      for (let i = 0; i < this.demoClick.length; i++) {
        if (
          this.demoClick[i].question == "First Name" ||
          this.demoClick[i].question == "LastName" ||
          this.demoClick[i].question == "DOB" ||
          this.demoClick[i].question == "SSN" ||
          this.demoClick[i].question == "Gender" ||
          this.demoClick[i].question == "Phone" ||
          this.demoClick[i].question == "Email" ||
          this.demoClick[i].question == "Street" ||
          this.demoClick[i].question == "City" ||
          this.demoClick[i].question == "Zip" ||
          this.demoClick[i].question == "State" ||
          this.demoClick[i].question == "Primary Insurance Name" ||
          this.demoClick[i].question == "ExternalId" ||
          this.demoClick[i].question == "Primary Insurance Number" ||
          this.demoClick[i].question == "Primary Insurance Group Name" ||
          this.demoClick[i].question == "Primary Insurance Image Upload" ||
          this.demoClick[i].question == "Secondary Insurance Name" ||
          this.demoClick[i].question == "Secondary Insurance Number" ||
          this.demoClick[i].question == "Secondary Insurance Group Name" ||
          this.demoClick[i].question == "Secondary Insurance Image upload"
        ) {
          this.choseBasic.push(this.demoClick[i]);
        }
      }
      this.demoClick = [];
    },
    setBasicRadio(val) {
      this.basicDetails.gender = val;
    },
    blankActiveDemo() {
      this.activeDemo = {
        reasonId: 0,
        visitDetailId: 0,
        setValue: 0,
        PhysicianId: "",
        demo: {
          questId: 0,
          srNo: 0,
          questName: "",
          question: "",
          answer: "",
          questionInputTypeId: 0,
          questTypeName: "",
          demoOptions: [],
        },
      };
      return this.activeDemo;
    },
    isCustomFound() {
      let found = false;
      for (let c = 0; c < this.contactInfo.length; c++) {
        for (let b = 0; b < this.choseBasic.length; b++) {
          if (
            this.contactInfo[c] == this.choseBasic[b].question.toLowerCase()
          ) {
            found = true;
            break;
          }
        }
      }
      return found;
    },
    visitTypeClick(ndx) {
      this.currentSelectedTypeId = this.types[ndx].visitTypeId;
      this.activeType = JSON.parse(JSON.stringify(this.types[ndx]));
      this.visitTypeReasons = [];
      const x = this.reasons.length;
      for (let i = 0; i < x; i++) {
        if (this.reasons[i].visitTypeId === this.activeType.visitTypeId) {
          this.visitTypeReasons.push(
            JSON.parse(JSON.stringify(this.reasons[i]))
          );
        }
      }
      this.activeReason = "";
      this.activeReason = JSON.parse(JSON.stringify(this.visitTypeReasons[0]));
    },

    //check values
    checkContact() {
      for (let j = 0; j < this.choseBasic.length; j++) {
        if (
          this.choseBasic[j].question == "Email" ||
          this.choseBasic[j].question == "Phone"
        ) {
          return true;
        }
      }
      return false;
    },

    backStageClick(step) {
      window.scrollTo(0, 0);
      if (step == 11 && this.isNew == false) {
        this.currentStep = 3;
        return;
      }
      if (step == 11) {
        if (this.isCustomFound() == true) {
          this.currentStep = 5;
          return;
        } else {
          this.currentStep = 4;
          return;
        }
      }

      if (step == 4) {
        this.currentStep = 4;
        return;
      }
    },

    checkPatient() {
      this.intDummyComm();
      this.dummyComm.extras1 = this.patientId;
      this.dummyComm.extras2 = this.Dos_1;
      const url = this.SERVER + "/STDS/StageDisplay/CheckVisitPat";
      const myData = this.dummyComm;

      this.axiosGetData(url, myData).then((res) => {
        //debugger
        this.loader.hide();
        if (res.extras == "0") {
          console.log("ok");
          this.currentStep = 3;
        } else {
          this.showMergeSwal();
        }
      });
    },

    showMergeSwal() {
      Swal.fire({
        title: "Are you sure?",
        text:
          "This Patient already has a visit for this Date of Service. Do you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.value) {
          this.currentStep = 3;
        }
      });
    },

    //**nextStageClick(step)
    nextStageClick(step) {
      //debugger
      window.scrollTo(0, 0);
      //Visit
      if (step === 4 && this.currentSelectedReasonId < 0) {
        this.warningToast("Enter Visit Reason");
        return;
      }

      if (step === 4 && this.isNew == false) {
        this.currentStep = 11;
        return;
      }

      if (step == 0) {
        window.history.go(-1);
        return;
      }
      if (this.checkinType == "") {
        this.warningToast("Select some Option");
        return;
      }

      //forCheckIn
      if (step == 1 && this.checkinType == "checkin") {
        this.currentStep = 1;
        return;
      }
      if (step === 3 && this.currentSelectedTypeId < 0) {
        this.warningToast("Enter Visit Type");
        return;
      }
      if (step == 3 && this.NewPat == "false") {
        this.checkPatient();
        return;
      }
      //Basic
      if (step === 5) {
        for (let r = 0; r < this.choseBasic.length; r++) {
          if (this.choseBasic[r].question == "Phone") {
            this.phoneVal = "Phone";
            if (this.choseBasic[r].isRequired == 1) {
              this.phoneRq = 1;
            }
          } else if (this.choseBasic[r].question == "Email") {
            this.emailVal = "Email";
            if (this.choseBasic[r].isRequired == 1) {
              this.emailRq = 1;
            }
          } else if (this.choseBasic[r].question == "SSN") {
            this.ssnVal = "SSN";
            if (this.choseBasic[r].isRequired == 1) {
              this.ssnRequire = 1;
            }
          }
        }
        if (this.basicDetails.firstName.length < 1) {
          this.warningToast("First Name is require");
          return;
        }
        if (this.basicDetails.lastName.length < 1) {
          this.warningToast("Last Name is require");
          return;
        }
        if (this.basicDetails.dob.length < 1) {
          this.warningToast("Date of birth is require");
          return;
        }
        if (this.basicDetails.gender == "") {
          this.warningToast("Choose a Gender");
          return;
        }
        if (this.ssnVal != "" && this.ssnRequire == 1) {
          if (this.basicDetails.ssn.length < 1) {
            this.warningToast("Security Number is require");
            return;
          }
          if (
            this.basicDetails.ssn != "" &&
            this.basicDetails.ssn.length < 11
          ) {
            this.warningToast("Security number of must be 9 length");
            return;
          }
        }
        if (!this.isValidateDate(this.basicDetails.dob)) {
          this.warningToast("Valid Date of Birth required");
          event.preventDefault();
          return;
        }

        //set DOB, SSN value
        this.valueSSN = this.choseBasic.filter((i) => i.question == "SSN");
        if (this.valueSSN.length == 1) {
          this.valueSSN = "SSN";
        } else {
          this.valueSSN = "";
        }

        this.newValDOB = "";
        this.newValDOB = moment(String(this.basicDetails.dob)).format(
          "MM-DD-YYYY"
        );

        let found = false;
        for (let c = 0; c < this.contactInfo.length; c++) {
          for (let b = 0; b < this.choseBasic.length; b++) {
            if (
              this.contactInfo[c] == this.choseBasic[b].question.toLowerCase()
            ) {
              found = true;
              break;
            }
          }
        }
        if (found == false) {
          this.currentStep = 11;
          return;
        }

        this.currentStep = 5;
        return;
      }

      //Contact
      if (step === 6) {
        for (let p = 0; p < this.choseBasic.length; p++) {
          if (this.choseBasic[p].question == "Street") {
            this.addVal = "Street";
            if (this.choseBasic[p].isRequired == 1) {
              this.streetRq = 1;
            }
          } else if (this.choseBasic[p].question == "City") {
            this.cityVal = "City";
            if (this.choseBasic[p].isRequired == 1) {
              this.cityRq = 1;
            }
          } else if (this.choseBasic[p].question == "State") {
            this.stateVal = "State";
            if (this.choseBasic[p].isRequired == 1) {
              this.stateRq = 1;
            }
          } else if (this.choseBasic[p].question == "Zip") {
            this.zipVal = "Zip";
            if (this.choseBasic[p].isRequired == 1) {
              this.zipRq = 1;
            }
          }
        }
        if (this.phoneVal != "" && this.phoneRq == 1) {
          if (this.basicDetails.phone.length < 1) {
            this.warningToast("Phone Number is require");
            return;
          }
        }
        if (
          this.basicDetails.phone != "" &&
          this.basicDetails.phone.length < 12
        ) {
          this.warningToast("Phone Number must be of 10 length");
          return;
        }

        if (this.emailVal != "" && this.emailRq == 1) {
          if (this.basicDetails.email.length < 1) {
            this.warningToast("Email is require");
            return;
          }
        }
        if (this.basicDetails.email.length > 0) {
          if (this.basicDetails.email != null) {
            if (!this.validEmail(this.basicDetails.email)) {
              this.Validity(this.e);
            }
          }
        }

        this.currentStep = 11;
        return;
      }

      this.alertShown = 0;
      this.currentStep = step++;
    },

    showCheckInModalNew() {
      this.showThisModelCheck = true;
      this.NewPat = "true";
      clearTimeout(this.call);
      clearTimeout(this.loaderTim);

      this.loader = this.$loading.show({
        color: "#03a9f3",
      });
      this.isNew = true;
      this.currentStep = 2;
      this.patientId = 0;
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Checkin/GtBscDta1";
      this.dummyComm.patientId = 0;
      const myData = this.dummyComm;

      this.axiosGetData(url, myData).then((res) => {
        this.loader.hide();
        if (res == "err") {
          this.showErrorToast("Unable to load data.");
        } else {
          this.showThisModelCheck = true;
          this.types = res.visits;
          this.reasons = res.reasons;
          this.demos_1 = res.demos_1;
        }
      });
    },
    async saveCheckinInfo_1() {
      await this.saveCheckinInfo();
    },
    async saveCheckinInfo() {
      debugger;
      this.call = setInterval(() => {
        this.showThisModelCheck = false;
      }, 4000);

      this.call1 = setInterval(() => {
        this.showThisModel = false;
      }, 4000);

      this.loader = this.$loading.show({
        color: "#03a9f3",
      });

      let stageStrt = new Date();
      this.basicDetails.stageTime =
        stageStrt.getFullYear() +
        "-" +
        String(stageStrt.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(stageStrt.getDate()).padStart(2, "0") +
        " " +
        String(stageStrt.getHours()).padStart(2, "0") +
        ":" +
        String(stageStrt.getMinutes()).padStart(2, "0") +
        ":" +
        String(stageStrt.getSeconds()).padStart(2, "0");

      //alert(currentdate.getFullYear());
      this.basicDetails.physicianId = this.activeReason.physicianId;
      this.basicDetails.externalId = "";

      this.Insurance = {
        primaryInsuranceName: "",
        primaryInsuranceNumber: "",
        primaryInsuranceGroup: "",
        primaryInsuranceId: "",
        secondaryInsuranceName: "",
        secondaryInsuranceNumber: "",
        secondaryInsuranceGroup: "",
        secondaryInsuranceId: "",
      };

      let getTime = new Date();
      let currentdate1 = new Date();
      this.newdate = moment(String(this.Dos_1)).format("MM/DD/YYYY");
      let ok = currentdate1.toLocaleDateString();

      const str = this.newdate;
      const arr = str.split("/");
      let one = arr[0].charAt(0);

      if (one == "0") {
        this.newdate = this.newdate.replace(0, "");
      }

      if (this.newdate === ok) {
        this.basicDetails.dos =
          currentdate1.toLocaleDateString() +
          " " +
          getTime.toLocaleTimeString();
      } else {
        this.basicDetails.dos =
          this.newdate + " " + getTime.toLocaleTimeString();
      }

      debugger; // eslint-disable-line no-debugger

      if (this.groupId === "") {
        this.groupId = new Date().getTime().toString();
      } else {
        this.groupId === this.groupId;
      }

      let myData = {
        visitTypeId: this.activeType.visitTypeId,
        visitDetailId: this.activeReason.visitDetailId,
        questDemos: [],
        basicDetail: this.basicDetails,
        Insurance: this.Insurance,
        dc: this.dummyComm,
        groupId: this.groupId,
        groupColor: this.groupColor,
      };

      this.intDummyComm();
      this.dummyComm.emailValue = this.basicDetails.email;
      this.dummyComm.smsValue = this.basicDetails.phone;
      this.dummyComm.extras2 = this.practName;

      myData.dc = this.dummyComm;
      myData.dc.patientId = this.patientId;

      myData.PhysicianId = this.PhysicianId;
      //this.valueSSN = "";
      const url = this.SERVER + "/VNSPRAAPI/Checkin/SvChknPatQuick";

      this.loaderTim = setInterval(() => {
        this.loader.hide();
      }, 4000);

      this.loaderTim1 = setInterval(() => {
        this.loader.hide();
      }, 4000);

      await this.axiosGetData(url, myData)
        .then((res) => {
          debugger;
          this.showThisModelCheck = false;
          this.showThisModel = false;
          this.loader.hide();
          if (res == "err") {
            this.showErrorToast("Unable to load data.");
          } else {
            debugger;
            
            this.groupId = res.groupId;
            this.groupColor = res.groupColor;
            this.patientList = res.groupedPatients;
            this.successToast();
            this.types = [];
            this.reasons = [];
            this.currentSelectedTypeId = -1;
            this.demos_1 = [];
            this.basicDetails = {
              pndx: 0,
              patientId: 0,
              firstName: "",
              lastName: "",
              currentdate: new Date(),
              dos: "",
              dob: "",
              gender: "",
              ssn: "",
              phone: "",
              email: "",
              address: "",
              city: "",
              zip: "",
              state: "",
            };
            this.showModal(res.groupId, res.groupColor);
            // this.$refs.quickCheckinInfo.newTabClick();
            // this.currentStep = 12;
          }
        })
        .catch(function(error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {});
    },

    showCheckInModal(pat) {
      this.NewPat = "false";
      clearTimeout(this.call);
      clearTimeout(this.loaderTim);

      this.loader = this.$loading.show({
        color: "#03a9f3",
      });
      this.isNew = false;
      this.currentStep = 2;
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Checkin/GtBscDta1";
      this.patientId = pat.patientId;
      this.dummyComm.patientId = this.patientId;
      const myData = this.dummyComm;

      this.axiosGetData(url, myData).then((res) => {
        this.loader.hide();
        if (res == "err") {
          this.showErrorToast("Unable to load data.");
        } else {
          //debugger
          this.showThisModelCheck = true;
          this.types = res.visits;
          this.reasons = res.reasons;
          this.demos_1 = res.demos_1;
          this.basicDetails = res.basic[0];
          this.newValDOB = "";
          this.newValDOB = moment(String(this.basicDetails.dob)).format(
            "MM-DD-YYYY"
          );
        }
      });
    },

    getAllPatients() {
      var loader = this.$loading.show({
        color: "#03a9f3",
      });
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetAllPatientsCheckin";
      //this.dummyComm.filter = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      let stageId = 0;

      //debugger
      const myData = {
        dc: this.dummyComm,
        filter: this.$store.state.filterSTGDSP,
        sortColumn: this.sortColumn,
        sortColumnOption: this.sortColumnOption,
        stageId: stageId,
      };

      this.axiosGetData(url, myData).then((res) => {
        loader.hide();
        if (res == "err") {
          this.showErrorToast("Unable to load data.");
        } else {
          this.suggestedPatients = res.allPatients;
          if (this.suggestedPatients != null) {
            for (let j = 0; j < this.suggestedPatients.length; j++) {
              this.suggestedPatients[j].dob = this.suggestedPatients[
                j
              ].dob.split("T")[0];
              this.suggestedPatients[j].dob = moment(
                String(this.suggestedPatients[j].dob)
              ).format("MM-DD-YYYY");
            }
          }
          this.totalRows = res.dc.totalRow;
          this.totalPages = res.dc.totalPages;
        }
      });
    },

    //-------------------- Common Methods
    async axiosGetData(myUrl, myData) {
      let data = "err";
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        contentType: "application/json",
        dataType: "json",
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          data = res.data;
        })
        .catch(function(err) {
          console.log(err);
        })
        .finally(() => {});

      return data;
    }, // axiosGetData
  }, // methods

  watch: {},
  mounted() {
    this.Dos_1 = moment(String(this.vDos)).format("YYYY-MM-DD");
    if (this.pat !== null) {
      this.showCheckInModal(this.pat);
    } else {
      this.showCheckInModalNew();
    }
  },
  unmounted() {
    clearTimeout(this.call);
    clearTimeout(this.loaderTim);
  },
};
</script>

<style scoped>
.activeColor {
  background-color: #fb9678;
  color: white;
}
.colorActive {
  color: #f95c2e;
}
.disabledColor {
  color: gray;
  background: lightgrey;
}
.asc-desc-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  color: honeydew;
  float: right;
}
#td1 {
  text-align: left;
  width: 320px;
}
#td2 {
  text-align: center;
}
</style>
